import { render } from "./Benchmark.vue?vue&type=template&id=842fda4a"
import script from "./Benchmark.vue?vue&type=script&lang=js"
export * from "./Benchmark.vue?vue&type=script&lang=js"

import "./Benchmark.vue?vue&type=style&index=0&id=842fda4a&lang=scss"
import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__